import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=073a839a"
import script from "./manager.vue?vue&type=script&lang=js"
export * from "./manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports